import { ref } from 'vue';

const globalAbortController = ref<AbortController | null>(null);

// Initialize the controller immediately so early requests have an abort signal
globalAbortController.value = new AbortController();

export default function () {
  function cancelAllRequests() {
    if (globalAbortController.value) {
      globalAbortController.value.abort();
      globalAbortController.value = null;
    }
  }

  function createNewController() {
    globalAbortController.value = new AbortController();
    return globalAbortController.value;
  }

  function getCurrentController() {
    // If controller doesn't exist, create one to ensure requests always have a signal
    if (!globalAbortController.value) {
      createNewController();
    }
    return globalAbortController.value;
  }

  return {
    cancelAllRequests,
    createNewController,
    getCurrentController,
  };
}
